<!-- 实现标签点击显示不同内容 -->

<template>
  <div class="Tech">
    <div style="text-align: center">
      <span style="background-color: rgb(56, 68, 118);
        display: block;
        height: 3px;
        margin: 0 auto 12px auto;
        width: 60px;
        
        "></span>
      <h3 class="techTitle">产品介绍</h3>
    </div>
    <div class="show">
      <a href="#product" style="text-decoration: none;color: inherit;">
        <div class="right2" id="right" v-if="currentItem">
          <div class="item-container" style="width: 50%; height: 400px;">
            <div class="item-content" style="display: flex; justify-content: center; height: 100%;">
              <div style="flex: 1; position: relative;">
                <div class="extra-text" style="position: absolute; 
                    top: 50%; 
                    left: 50%;
                    transform: translate(-50%, -20%); 
                    color: aliceblue;">
                  <span v-html="currentItem.content"></span>

                </div>

                <img :src="currentItem.picLink" />
              </div>

              <div style="flex: 2; ">
                <div class="current-introdution">
                  <span style="display:block;text-indent:2em;" v-html="currentItem.introduction"></span>
                </div>
                <div style="height: 20%;
                  display: flex;
                  align-items: center;
                  justify-content: end;">
                  <button style="   
                      padding:0.5rem 2rem;
                      font-size: 23px;
                      font-family: fantasy;
                      background-color: rgb(38,38,38);
                      color: #ccc;
                      border-radius: 6%;
                      border: 0;
                      cursor: pointer;
                      
                      "><a style="text-decoration: none; color: #ccc;" :href="currentItem.applyLink"
                      target="_blank">了解更多</a></button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div v-if="currentItem" style="width: 50%;height: 100%;">
          <el-row style="    display: flex;
    justify-content: center;
    align-items: center;">
            <el-col :span="12">
              <img :src="currentItem.picLink" alt="" style="width: 150%; height: 100%">
            </el-col>
            <el-col :span="12">
              <span v-html="currentItem.introduction"></span>
            </el-col>
          </el-row>
        </div> -->
        <div class="right1">
          <span class="btn_anniu" v-for="item in button_list" :key="item.id" @click="change(item.id)"
            :class="{ newStyle: item.id === number, noHover: item.id === number }">{{ item.name }}</span>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { getProductList } from '../utils/api.js'
import $ from 'jquery'

export default {
  name: "show",
  data() {
    return {
      number: 1,
      currentItem: {}, // 初始显示第一个内容
      button_list: [],
      hrefs: [
        // {
        //   id:1,
        //   href:
        // }
      ]
    };
  },
  created() {
    // this.currentItem = this.button_list[0]; // 初始化默认选中第一项
    this.load()

  },
  methods: {
    load() {
      getProductList().then(res => {
        if (res.code === 200) {
          // console.log(res.data)
          this.button_list = res.data
          this.currentItem = res.data[0]
          this.number = res.data[0].id; // 设置初始值
        }
      })
    },
    change(id) {
      this.number = id;
      // debugger
      $('#right').fadeOut()
      setTimeout(() => {
        this.currentItem = this.button_list.find((item) => item.id === id);
        $('#right').fadeIn()
      }, 400);
    },
  },
};
</script>

<style>
.Tech .extra-text {
  margin-bottom: 10px;
  font-size: 14px;
  color: #666;
}

.Tech .techTitle {
  color: #ccc;
  padding: 5px 30px 30px;
  font-size: 30px;
  font-weight: bold;

}

.Tech .techContent {
  color: #7f7f7f;
  letter-spacing: 2px;
  line-height: 25px;
  text-align: center;
  padding: 20px;
  width: 500px;
  margin: 0 auto;
  /* Center align the div */
}

/* span悬停效果 */
.Tech .right1 .newStyle {
  border-bottom: 3px solid #384476 !important;
  /* color: #384476 !important; */
  font-weight: bold !important;
}

/* 悬停不影响span选定样式 */
.Tech .noHover:hover {
  color: initial;
  background-color: initial;
}

.Tech .btn_anniu {
  cursor: pointer;
}

/* 悬停效果 */
.Tech .btn_anniu:hover {
  color: #fff;
}

/* 内容动画淡入淡出 */
.Tech .fade-enter-active,
.Tech .fade-leave-active {
  transition: opacity 0.5s;
}

.Tech .fade-enter,
.Tech .fade-leave-to {
  opacity: 0;
}

.Tech .right2 {
  display: flex;
  justify-content: center;
  /* 水平居中 */
  align-items: center;
  /* 垂直居中 */

}

.Tech .right2 img {
  float: left;
  margin-right: 10px;
  /* width: 150%; */
  height: 100%;
  padding-right: 20px;
}

.Tech .right2 p {
  width: 100% !important;
  height: 100% !important;
  line-height: 20px;
  overflow: hidden;
}

.Tech .right1 {
  /* height: 50px; */
  display: flex;
  display: flex;
  justify-content: center;
  padding-top: 20px;
}

.Tech .right1 span {
  cursor: pointer;
  padding: 15px;
}
.Tech .current-introdution{
  height: 80%;width: 100%;overflow-y: auto;
  scrollbar-width: thin; /* 适用于Firefox */
  scrollbar-color: #888 rgba(0,0,0,0); /* 滑块颜色 轨道颜色 */
}
/* 自定义滚动条样式 - 适用于Webkit浏览器 (Chrome, Safari) */
.Tech .current-introdution::-webkit-scrollbar {
  width: 8px; /* 滚动条宽度 */
}

.Tech .current-introdution::-webkit-scrollbar-thumb {
  background-color: #888; /* 滑块颜色 */
  border-radius: 10px; /* 滑块圆角 */
}

.Tech .current-introdution::-webkit-scrollbar-track {
  background: #eee; /* 轨道颜色 */
  border-radius: 10px; /* 轨道圆角 */
}


/*去除a标签下划线*/
</style>
